/**
 * Typography Design Tokens
 *
 * ⭐ MODIFY FONTS HERE
 * Change these values to update the entire app's typography
 */

export const typography = {
  fontFamily: {
    display: ['Inter', 'system-ui', 'sans-serif'],  // CHANGE ME
    sans: ['Inter', 'system-ui', 'sans-serif'],      // CHANGE ME
    mono: ['JetBrains Mono', 'Courier New', 'monospace'],
  },

  fontSize: {
    xs: '0.75rem',      // 12px - Labels, badges
    sm: '0.875rem',     // 14px - Body small
    base: '1rem',       // 16px - Body
    lg: '1.125rem',     // 18px - Large body
    xl: '1.25rem',      // 20px - Subheadings
    '2xl': '1.5rem',    // 24px - Section headings
    '3xl': '1.875rem',  // 30px - Page headings
    '4xl': '2.25rem',   // 36px - Hero headings
    '5xl': '3rem',      // 48px - Large hero
  },

  fontWeight: {
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },

  lineHeight: {
    tight: 1.2,
    normal: 1.5,
    relaxed: 1.75,
  },
} as const;
